// extracted by mini-css-extract-plugin
module.exports = {"landing_page_F1":"F1_landing_page_F1__wsOXf"};